import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { TreeUtils } from '@/common/utils/TreeUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import { FinanceDashboardAgingReservesCard } from '../cards/FinanceDashboardAgingReservesCard';
import { FinanceDashboardCardChart } from '../cards/FinanceDashboardCardChart';
import { FinanceDashboardMcoPbmTrendCard } from '../cards/FinanceDashboardMcoPbmTrendCard';
import { FinanceDashboardGrowthChart } from '../charts/FinanceDashboardGrowthChart';
import { FinanceDashboardReservesChart } from '../charts/FinanceDashboardReservesChart';

export const DemFinanceDashboardBsView = ({ startPeriod, endPeriod, periodicity, prodIds, channelIds, channelTree }) => {

  const mcoId = channelTree
    ? TreeUtils.parseTree(channelTree).codeToNode['RB_UBC_MCO'].id
    : null;

  const mcoOnly = channelIds.length === 1 && channelIds[0] === mcoId;

  const [onExportClick, setOnExportClick] = useState();

  const downloadButton = (
    <IconButton size="small" onClick={onExportClick}>
      <FontAwesomeIcon icon={fas.faArrowCircleDown} />
    </IconButton>
  )

  return (
    <SpacerLayout>
      <Spacer>
        <Spacer vertical>
          <DashboardCard weights={[3, 2, 1]} title="Reserves Monitoring" buttons={downloadButton}>
            <FinanceDashboardReservesChart entity="RESERVE" chartType="MONITOR" startPeriod={startPeriod} endPeriod={endPeriod} periodicity={periodicity} prodIds={prodIds} channelIds={channelIds} setOnExportClick={setOnExportClick}/>
          </DashboardCard>
          <DashboardCard>
            <FinanceDashboardGrowthChart entity="RESERVE" changeType="percent" startPeriod={startPeriod} endPeriod={endPeriod} periodicity={periodicity} prodIds={prodIds} channelIds={channelIds} />
          </DashboardCard>
          <Spacer vertical>
            <Spacer>
              <FinanceDashboardCardChart entity="RESERVE" direction="Increase" changeType="percent" startPeriod={startPeriod} endPeriod={endPeriod} periodicity={periodicity} prodIds={prodIds} channelIds={channelIds} />
              <FinanceDashboardCardChart entity="RESERVE" direction="Decrease" changeType="percent" startPeriod={startPeriod} endPeriod={endPeriod} periodicity={periodicity} prodIds={prodIds} channelIds={channelIds} />
            </Spacer>
            <Spacer>
              <FinanceDashboardCardChart entity="RESERVE" direction="Increase" changeType="amount" startPeriod={startPeriod} endPeriod={endPeriod} periodicity={periodicity} prodIds={prodIds} channelIds={channelIds} />
              <FinanceDashboardCardChart entity="RESERVE" direction="Decrease" changeType="amount" startPeriod={startPeriod} endPeriod={endPeriod} periodicity={periodicity} prodIds={prodIds} channelIds={channelIds} />
            </Spacer>
          </Spacer>
        </Spacer>
        <Spacer vertical>
          <FinanceDashboardAgingReservesCard startPeriod={startPeriod} endPeriod={endPeriod} periodicity={periodicity} prodIds={prodIds} channelIds={channelIds} />
          { mcoOnly &&
            <FinanceDashboardMcoPbmTrendCard startPeriod={startPeriod} endPeriod={endPeriod} periodicity={periodicity} prodIds={prodIds} />
          }
        </Spacer>
      </Spacer>
    </SpacerLayout>
  )
}